import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer className="border-t border-border/70 bg-secondary/30">
    <div className="mx-auto grid max-w-7xl gap-8 px-6 py-14 sm:px-8 md:grid-cols-5">
      <div className="md:col-span-2">
        <Logo size={28} />
        <p className="mt-4 max-w-sm text-sm text-muted-foreground">Create. Advertise. Grow. Professional AI images, advertisements and social creatives in seconds.</p>
      </div>
      <div>
        <p className="eyebrow text-muted-foreground mb-3">Product</p>
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li><Link to="/create" className="hover:text-foreground">Create</Link></li>
          <li><Link to="/pricing" className="hover:text-foreground">Pricing</Link></li>
          <li><Link to="/examples" className="hover:text-foreground">Examples</Link></li>
        </ul>
      </div>
      <div>
        <p className="eyebrow text-muted-foreground mb-3">Company</p>
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li><Link to="/contact" className="hover:text-foreground">Contact</Link></li>
          <li><Link to="/login" className="hover:text-foreground">Login</Link></li>
        </ul>
      </div>
      <div data-testid="footer-legal-col">
        <p className="eyebrow text-muted-foreground mb-3">Legal</p>
        <ul className="space-y-2 text-sm text-muted-foreground">
          <li><Link to="/terms" className="hover:text-foreground" data-testid="footer-link-terms">Terms of Service</Link></li>
          <li><Link to="/privacy" className="hover:text-foreground" data-testid="footer-link-privacy">Privacy Policy</Link></li>
          <li><Link to="/terms-paid-services" className="hover:text-foreground" data-testid="footer-link-terms-paid">Terms of Paid Services</Link></li>
          <li><Link to="/credits-policy" className="hover:text-foreground" data-testid="footer-link-credits-policy">Credits Policy</Link></li>
          <li><Link to="/community-guidelines" className="hover:text-foreground" data-testid="footer-link-community">Community Guidelines</Link></li>
          <li><Link to="/copyright-policy" className="hover:text-foreground" data-testid="footer-link-copyright">Copyright Complaint Policy</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-border/60 py-5 text-center text-xs text-muted-foreground">
      © {new Date().getFullYear()} AdGen Store. All rights reserved.
    </div>
  </footer>
);
